import React from 'react';
import NotificationsTable from './NotificationsTable';

export default function UpcomingNotifications({ rows, listLoading, onOpenActionMenu }) {
    return (
        <NotificationsTable
            rows={rows}
            listLoading={listLoading}
            showActions
            onOpenActionMenu={onOpenActionMenu}
        />
    );
}
